export default __webpack_public_path__ + "static/media/none.a00d5a33.svg";